export default "/images/points.svg?85352c44885aa976a08023d9ddfd21a3";